async function fetchUserNotifications() {
    if (typeof isLimitAccess === 'undefined') {
        return;
    }

    if (!this.currentUser || isLimitAccess) {
        return;
    }

    const [err, responseData] = await to(
        api.user.notifications()
    );

    let userNotifications = {};

    if (!err) {
        userNotifications = _.get(responseData, 'data', []);
    }

    if (typeof userNotifications.unread_message_count !== 'undefined') {
        this.store.commit('setConversationUnreadMessageCount', userNotifications.unread_message_count);
    }

    if (typeof userNotifications.new_profile_view_count !== 'undefined') {
        this.store.commit('setUserProfileViewsNotificationCount', userNotifications.new_profile_view_count);
    }
}

async function periodicallySyncUserNotifications() {
    // first fetch right now
    this.fetchUserNotifications();

    if (this.userNotificationIntervalId) {
        return;
    }

    this.userNotificationIntervalId = setInterval(() => {
        this.fetchUserNotifications();
    }, this.userNotificationIntervalTimeout);
}

function destroyPeriodicalUserNotificationSyncer() {
    if (this.userNotificationIntervalId) {
        clearInterval(this.userNotificationIntervalId);
    }
}

export default {
    data() {
        return {
            store: $store,
            userNotificationIntervalId: null,
            userNotificationIntervalTimeout: 60000, // every 60s
        }
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {
        fetchUserNotifications,
        periodicallySyncUserNotifications,
        destroyPeriodicalUserNotificationSyncer,
    },
}
